import type { SxProps, Theme } from "@mui/material/styles";

export const frame =
  (height: number): SxProps<Theme> =>
  (theme) => ({
    position: "relative",
    height,
    borderRadius: 1.5,
    overflow: "hidden",
    border: `1px solid ${theme.palette.divider}`,
    bgcolor: theme.palette.background.default,
    // Keep Leaflet panes under MUI dialogs/menus.
    "& .leaflet-container": { zIndex: 0, fontFamily: "inherit" },
  });

export const locateButton: SxProps<Theme> = (theme) => ({
  position: "absolute",
  bottom: 12,
  right: 12,
  zIndex: 500,
  display: "inline-flex",
  alignItems: "center",
  gap: 0.75,
  px: 1.5,
  py: 0.875,
  borderRadius: 999,
  bgcolor: "background.paper",
  boxShadow: theme.shadows[3],
  fontFamily: "inherit",
  fontSize: "0.75rem",
  fontWeight: 700,
  color: "primary.main",
});

export const hintChip: SxProps<Theme> = (theme) => ({
  position: "absolute",
  top: 12,
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 500,
  px: 1.5,
  py: 0.625,
  borderRadius: 999,
  bgcolor: "rgba(31, 31, 31, 0.78)",
  color: "#fff",
  fontSize: "0.71875rem",
  fontWeight: 600,
  whiteSpace: "nowrap",
  pointerEvents: "none",
  boxShadow: theme.shadows[2],
});
